
import React, { useState, useEffect } from 'react';
import { Collapse, Select, Spin } from 'antd';
import Segmented from "../../../components/segmented/Segmented.jsx";
import { useSearchParams } from "react-router-dom";
import { GetAllFaqApi } from '../../../api/request/faq.js';

const { Panel } = Collapse;

export default function Faq() {

  const [filter, setFilter] = useState('Account');
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const getFaq = async () => {
    try {
      setIsLoading(true);
      let params = {
        FilterText: filter.replace(/\s/g, '')
      }
      const { data } = await GetAllFaqApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(data?.data?.[0]?.questionList);
      }
      setIsLoading(false);
      } catch (error) {
        setData([]);
        setIsLoading(false);
    }
  }

  useEffect(() => {
    if (searchParams?.get('filter')) {
      setFilter(searchParams?.get('filter'));
    }
  }, []);

  useEffect(() => {
    setSearchParams(`filter=${filter}`);
    getFaq();
  }, [filter]);

  const customExpandIcon = ({ isActive }) => (
    <span>
      {isActive ?
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 mt-2">
          <path fill-rule="evenodd" d="M4.25 12a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z" clip-rule="evenodd" />
        </svg>
        :
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 mt-2">
          <path fill-rule="evenodd" d="M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd" />
        </svg>
      }
    </span>
  );
const options = ['Account', 'Deposit', 'Client', 'Meta Trader', 'Withdrawal', 'Internal Transfer'];
  return (
    <div>
      <Select
       className="min-w-44  ant-select-selector-white"
       value={filter}
       onChange={(value) => { setFilter(value); }}
       options={options.map(option => ({ label: option, value: option }))}
       />
      <div className='border-[2px] border-light rounded-xl p-4 lg:p-6 w-full mt-5'>
        <p className='primary text-lg font-semibold mb-6'>{filter} FAQs</p>
        <div>
          {isLoading ? (
            <div className="flex justify-center flex-col my-[10%]">
              <Spin size="large" />
              <p className="primary text-center mt-2">Loading...</p>
            </div>
          ) : (
            <div>
              {
                data?.length > 0 ? (
                  <Collapse bordered={false} expandIcon={customExpandIcon}>
                    {data?.map((faq) => (
                      <Panel header={faq?.question} key={faq?.questionId} className="custom-panel">
                        <p dangerouslySetInnerHTML={{ __html: faq?.answer }}></p>
                      </Panel>
                    ))}
                  </Collapse>
                ) : (
                  <p className='text-center primary my-[12%]'>No Record Found</p>
                )
              }
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
